class Actions {
    static toggleVideoState = (source, video) => {
        if(video.paused){
            source.classList.add('video-playing');
            source.ariaLabel = source.dataset.labeloff;
            video.play();
        }
        else{
            source.classList.remove('video-playing');
            source.ariaLabel = source.dataset.labelon;
            video.pause();
            
        }
    }
}